module.exports = __webpack_public_path__ + "media/insights/palm_tree_icon-aa2cc735.png";